// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".breadcrumb[data-v-9dddaa90]{display:flex}.breadcrumb .breadcrumb-item[data-v-9dddaa90]{color:var(--accent-color)!important;font-size:11px;font-weight:400;letter-spacing:.08em}.breadcrumb .breadcrumb-item[data-v-9dddaa90]:last-of-type{font-weight:700}.breadcrumb .breadcrumb-item[data-v-9dddaa90]:not(:last-of-type):after{content:\"/\"}.breadcrumb .breadcrumb-item[data-v-9dddaa90]:not(:first-of-type){margin-left:4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
